function a(a){return null!==a&&"object"==typeof a?"share"in navigator&&"canShare"in navigator&&navigator.canShare(a):"share"in navigator}export{a as isWebShareSupported};
//# sourceMappingURL=is-web-share-supported.js.map
